<template>
  <el-form ref="ff" :model="formdata">
    <el-form-item label="选择人员" prop="UserId" required>
      <staffPicker :value="formdata.UserName" clearable @selectHandler="pickStaff" style="width: 100%" />
    </el-form-item>
    <el-form-item label="调整价格" prop="Price" required>
      <el-input v-model="formdata.Price" placeholder="请输入" />
    </el-form-item>
    <el-form-item>
      <el-button type="danger" @click="onSubmit">确定</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  components: {
    staffPicker: () => import("@/views/company/branch/staff/_input.vue")
  },
  data () {
    return {
      formdata: { ...this._form }
    }
  },
  props: {
    _form: { type: Object },
    callback: { type: Function },
    layerid: { type: String, default: null }
  },
  methods: {
    //选择客户
    pickStaff (res) {
      this.formdata.UserId = res.Id
      this.formdata.DeptId = res.Dept.Id
      this.formdata.UserName = res.Name
    },
    //提交
    onSubmit () {
      this.$refs['ff'].validate(valid => {
        if (valid && !this.loading) {
          this.$apis.mall.order.item.setting(this.formdata).then(() => {
            this.callback()
            this.$layer.close(this.layerid)
          }).catch(e => {
            this.$message.error(e || "执行错误")
          })
        }
      })
    }
  }
}
</script>